import { Component, OnInit, NgZone, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { first } from 'rxjs/operators';

import { Member } from '../_models/member';
import { ApiService, AlertService } from '../_services';
import { JwtHelper } from '../_services/jwt-helper';
import { environment } from '../../environments/environment';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatStepper } from '@angular/material';
import * as $ from 'jquery';
import * as _ from 'lodash';
import { Router } from '../../../node_modules/@angular/router';
import { Http } from '@angular/http';
import { WhitelabelService } from '../_services/whitelabel.service';
import { Benefit } from '../_models/benefit.model';
import { MemberService } from '../_services/member.service';
import { AppComponent } from '../app.component';
import { DependentService } from '../_services/dependent.service';
import { Dependent } from '../_models/dependent.model';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.scss']
})
export class HomeComponent implements OnInit {
    @ViewChild('stepper') stepper: MatStepper;
    @ViewChild('notificationBlockOver18') notificationBlockOver18: ElementRef;
    @ViewChild('notificationBlockDependentFeature') notificationBlockDependentFeature : ElementRef;
    Appcomponent: AppComponent
    needAddAssociates: boolean;
    openIdTokenParams: any;
    //users: User[] = [];
    memberId: string;
    currentMember: Member;
    currentDependent: any;
    dependentId: string;
    benefits: Benefit[];
    basedOnWhitelabels = true;
    isDependent: boolean = false;
    
    isLinear :boolean= false;
    loading= false;
    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;
    authService: any ={};
    hasTMBenefit= false;
    over18Message = '';

  AppComponent = AppComponent;

    constructor(public whitelabelService: WhitelabelService, private http: Http, private apiService: ApiService,
        private memberService: MemberService, private dependentService : DependentService,
        private changeDetectoRef: ChangeDetectorRef,
        protected sanitizer: DomSanitizer,
         private alertService: AlertService, private _formBuilder: FormBuilder,private ngZone: NgZone, private router: Router) {
        this.openIdTokenParams = JSON.parse(localStorage.getItem('openIdTokenParams'));
        // console.log('home')
        this.getMember();

        if(localStorage.getItem('basedOnWhitelabels')){
            this.basedOnWhitelabels = JSON.parse(localStorage.getItem('basedOnWhitelabels'))
        }
    }

    ngOnInit() {
        //this.loadAllUsers();
        this.firstFormGroup = this._formBuilder.group({
            firstCtrl: ['', Validators.required]
          });
          this.secondFormGroup = this._formBuilder.group({
            secondCtrl: ['', Validators.required]
          });
        var currentMember = JSON.parse(localStorage.getItem("currentMember"));
        var currentDependent = JSON.parse(localStorage.getItem("currentDependent"));
        // console.log(currentDependent.memberPolicies)
       
        if(currentMember){
            this.getBenefits(currentMember)
        }

        console.log(this.whitelabelService.whitelabelConfigsButtons)

        _.each(this.whitelabelService.whitelabelConfigsButtons, c=>{
            c.featureSettingsObj.text = this.sanitizer.bypassSecurityTrustHtml(c.featureSettingsObj.text);
        })


        // console.log(AppComponent.hasSSOTelemed)
        // AppComponent.hasSSOTelemed = false;
        // console.log(AppComponent.hasSSOTelemed)
    }

    getBenefits(currentMember){
        // this.apiService.getBenefitsByProductId(currentMember.currentProductId).subscribe(r=>{
        //     this.ngZone.run(()=>{
        //         this.benefits = r;
        //         this.hasTMBenefit = _.some(this.benefits, b=>{ return b.benefitCode.startsWith('TM4') || b.benefitCode.startsWith('MYLIFEW') });
        //     })

        // })
        // console.log(this.whitelabelService.whitelabelConfigs)
    }

    checkSSOtelemed(productId){
        this.whitelabelService.checkProductSSOTelemed(productId).subscribe(te => {
            AppComponent.hasSSOTelemed = (te != null);
        })
    }

    getMember(){
        if(! this.openIdTokenParams) return;

        this.loading= true;
        let jwtHelper = new JwtHelper();
        let decodedIdToken = jwtHelper.decodeToken(this.openIdTokenParams.id_token);
        console.log(decodedIdToken)
        if (decodedIdToken.EntityType) {
            this.dependentId = decodedIdToken.sub;
            this.dependentService.getDependentById(this.dependentId).subscribe( async d => {
                this.currentDependent = d as Dependent;
                this.isDependent = true;
                console.log('dependent', d)
                this.checkSSOtelemed(this.currentDependent.memberPolicies[0].productId)
                await this.getWhitelabelByUrl();
                localStorage.setItem('currentDependent',JSON.stringify(this.currentDependent))
                this.memberService.setDependent(JSON.parse(localStorage.getItem('currentDependent')));
                this.loading = false;
                this.router.navigate(['/'])
                // this.memberService.currentDependent = this.currentDependent
                if (!this.benefits) {
                    this.getBenefits(this.currentDependent)
                }
            }, err => {this.router.navigate(['/'])});
        } else {
            this.memberId = decodedIdToken.sub;
            this.apiService.getMemberById(this.memberId).subscribe(async m => {
                this.currentMember = m as Member;
                if (!this.currentMember.active) {
                    console.log(this.currentMember)
                    this.router.navigate(["/login"])
                    this.memberService.logout()
                }
                //this.memberService.memberChanged.emit(null);
                await this.getWhitelabelByUrl();
                if (!this.benefits) {
                    this.getBenefits(this.currentMember)
                }
                console.log(this.currentMember);

                this.checkSSOtelemed(this.currentMember.memberPolicies[0].productId)

                localStorage.setItem("currentMember", JSON.stringify(this.currentMember));
                this.loading = false;
                this.router.navigate(['/']);
                this.memberService.currentMember = this.currentMember;
                this.memberService.memberChanged.emit();
                if (!this.currentMember.dependentFeatureNotified) { //false
                    $(this.notificationBlockDependentFeature.nativeElement).show(1000)
                }else{
                    this.dependentService.getParentMemberNotifiedOver18(this.currentMember.memberId).subscribe(r => {
                        if (r.length > 0) {
                            this.over18Message = AppComponent.siteBranding.turnOver18Message;
                            $(this.notificationBlockOver18.nativeElement).show(1000)
                        }
                    })
                }
                //
            }, err => {
                console.log(err);
                this.router.navigate(['/login']);
            })
        }
    }

    async getWhitelabelByUrl(){
        var w = AppComponent.whitelabel;
        if(!this.currentMember){
            this.currentDependent.currentProductId = w.productId;
            this.currentDependent.currentProduct = w.product;
        }else{
            this.currentMember.currentProductId = w.productId;
            this.currentMember.currentProduct = w.product;
        }
        
    }

    //sign in to telemed for life
    loginSSOCareington(){
       this.isDependent? this.dependentLoginSSOCareington() : this.memberLoginSSOCareington()
    }

    async dependentLoginSSOCareington(){
        if(!this.currentDependent.currentProductId){
            var w =  AppComponent.whitelabel;
            this.currentDependent.currentProductId = w.productId;
        }

        if (this.currentDependent) {
            this.dependentService.dependentSSOLogin(this.currentDependent.dependentId, this.currentDependent.currentProductId).subscribe(r => {
                top.window.open( r.redirectSSOUrl, '_blank');
                console.log(r)
            })
        }
    }

    async memberLoginSSOCareington(){
        if(!this.currentMember.currentProductId){
            var w =  AppComponent.whitelabel;
            this.currentMember.currentProductId = w.productId;
        }

        if (this.currentMember.memberSSOProviderStatuses.length > 0 && this.currentMember.memberSSOProviderStatuses[0].status == 0) {
            //now we call pre-register again
            this.apiService.addAssociates(this.currentMember.memberId, this.currentMember.currentProductId, 0, []).subscribe(r => {
                this.apiService.ssoLogin(this.currentMember.memberId, this.currentMember.currentProductId).subscribe(r => {
                    top.window.open(r.redirectSSOUrl, '_blank');
                });
            }, err => {
                console.log("error: " + err);
                this.alertService.error("Please contact support at 1-866-500-7065");
                $('html, body').animate({
                    scrollTop: ($('ng2-toasty').first().offset().top)
                }, 500);
                return;
            })
        } else {
            this.apiService.ssoLogin(this.currentMember.memberId, this.currentMember.currentProductId).subscribe(r => {
                top.window.open(r.redirectSSOUrl, '_blank');
            });
        }
    }

    loginSSOGenGold(){
        this.apiService.ssoGenGoldLogin(this.memberId,  this.currentMember.currentProductId).subscribe(r=>{
            if(r.success){
                top.window.open( r.data.login_url, '_blank');
            }else{
                this.alertService.error(r.message);
            $('html, body').animate({
                scrollTop: ($('ng2-toasty').first().offset().top)
            },500);
            return;
            }
        });
    }

    loginSSOMaestro(){
        if(!this.memberId){
            this.alertService.error("Not support dependent yet.");
            $('html, body').animate({
                scrollTop: ($('ng2-toasty').first().offset().top)
            },500);
            return;
        }
        this.apiService.ssoMaestroLogin(this.memberId,  this.currentMember.currentProductId).subscribe(r=>{
            if(r.url){
                top.window.open( r.url, '_blank');
            }else{
                this.alertService.error(r.message);
            $('html, body').animate({
                scrollTop: ($('ng2-toasty').first().offset().top)
            },500);
            return;
            }
        });
    }

    loginSSOWordPress(){
        var ssoWpConfig =  JSON.parse(this.whitelabelService.getSettingByFeatureName('ssowp'));

        $('body').append('<form action="' +  environment.apiBaseUrl+"connect/authorize/"+'" method="post" id="postToIframe"></form>');
        $('#postToIframe').append('<input type="hidden" name="client_id" value="LA_Member_Portal" />');
        $('#postToIframe').append('<input type="hidden" name="response_type" value="code" />');
        $('#postToIframe').append('<input type="hidden" name="scope" value="openid email phone profile roles" />');      
        $('#postToIframe').append('<input type="hidden" name="redirect_uri" value="'+ ssoWpConfig.oauthcallback +'" />');

        $('#postToIframe').append('<input type="hidden" name="memberId" value="' + this.currentMember.memberId + '" />');
        $('#postToIframe').append('<input type="hidden" name="productId" value="' + this.currentMember.currentProductId + '" />');
        $('#postToIframe').append('<input type="hidden" name="zipcode" value="' + this.currentMember.zipcode + '" />');

        $('#postToIframe').submit().remove();
    }

    loginSSORF(){
        this.apiService.ssoRFLogin(this.memberId,  this.currentMember.currentProductId).subscribe(r=>{
            
            $('body').append('<form target="_blank" action="' + r.url + '" method="post" id="postToIframe"></form>');
            $('#postToIframe').append('<input type="hidden" name="UID" value="'+ r.uid + '" />');
            $('#postToIframe').append('<input type="hidden" name="site_id" value="' + r.siteId + '" />');
            $('#postToIframe').submit().remove();
        }, err=>{
            console.log(err)
        });
    }

    loginSSOOpenLink(){
        var otherbenefits = JSON.parse(this.whitelabelService.getSettingByFeatureName('ssoOpenLink'));
        window.open(otherbenefits.link, '_blank')
    }

    loginSSOTelepet(){
        if(!this.memberId){
            this.alertService.error('Not support dependent yet.');
            $('html, body').animate({
                scrollTop: ($('ng2-toasty').first().offset().top)
            },500);
            return;
        }
        this.loading = true;
        this.apiService.ssoTelepetLogin(this.currentMember.memberId, this.currentMember.currentProductId).subscribe(r => {
            console.log(r)
            this.loading = false
            if(r.success){
                var url = `http://dev.mytelemedicine.com/lexi/login/sso/${r.accessToken}`;
                window.open(r.redirectUrl)
            }else{
                this.alertService.error(r.message)
            }

        });
        
    }
    openLink(link){
        window.open(link, '_blank')
    }

    loginOtherBenefits(){

        var ssoWpConfig =  JSON.parse(this.whitelabelService.getSettingByFeatureName('ssowp'));
        var otherbenefits = JSON.parse(this.whitelabelService.getSettingByFeatureName('otherbenefits'));
        var ssoGenGold = JSON.parse(this.whitelabelService.getSettingByFeatureName('ssogengold'));
        if(ssoWpConfig && ssoWpConfig.oauthcallback){
            
            $('body').append('<form action="' +  environment.apiBaseUrl+"connect/authorize/"+'" method="post" id="postToIframe"></form>');
            $('#postToIframe').append('<input type="hidden" name="client_id" value="LA_Member_Portal" />');
            $('#postToIframe').append('<input type="hidden" name="response_type" value="code" />');
            $('#postToIframe').append('<input type="hidden" name="scope" value="openid email phone profile roles" />');      
            $('#postToIframe').append('<input type="hidden" name="redirect_uri" value="'+ ssoWpConfig.oauthcallback +'" />');

            $('#postToIframe').append('<input type="hidden" name="memberId" value="' + this.currentMember.memberId + '" />');
            $('#postToIframe').append('<input type="hidden" name="productId" value="' + this.currentMember.currentProductId + '" />');
            $('#postToIframe').append('<input type="hidden" name="zipcode" value="' + this.currentMember.zipcode + '" />');

            $('#postToIframe').submit().remove();

        }
        else if(otherbenefits && otherbenefits.link){
            window.open(otherbenefits.link, '_blank')
        }
        else if(ssoGenGold && ssoGenGold.ssogengold){
            this.loginSSOGenGold();
        }else{
            this.apiService.ssoRFLogin(this.memberId,  this.currentMember.currentProductId).subscribe(r=>{
            
                $('body').append('<form target="_blank" action="' + r.url + '" method="post" id="postToIframe"></form>');
                $('#postToIframe').append('<input type="hidden" name="UID" value="'+ r.uid + '" />');
                $('#postToIframe').append('<input type="hidden" name="site_id" value="' + r.siteId + '" />');
                $('#postToIframe').submit().remove();
            }, err=>{
                console.log(err)
            });
        }

    }

    startsWith(code, str){
        return code.startsWith(str);
    }

    closeNotification(){
        $(this.notificationBlockOver18.nativeElement).hide(500)
        $(this.notificationBlockDependentFeature.nativeElement).hide(500)
    }

    goToDependents(){
        this.router.navigate(['dependent'])
    }

    activeDependentFeatureNotificated(){
        if (!this.currentMember.dependentFeatureNotified) {
            this.apiService.activeDependentFeatureNotified(this.currentMember.memberId).subscribe( r =>{
                console.log(r);
                if(r){
                    this.apiService.getMemberById(this.currentMember.memberId).subscribe( m => {
                        this.currentMember = m as Member;
                        localStorage.setItem("currentMember", JSON.stringify(this.currentMember));
                        this.memberService.currentMember = this.currentMember;
                        $(this.notificationBlockDependentFeature.nativeElement).hide(500)
                        this.router.navigate(['dependent'])
                    } )
                }
            } )
        }
    }

    loginSSOEnrich(){
        var link = `${environment.apiBaseUrl}api/ssoenrich/sso-login?memberId=${this.memberId}&productId=${this.currentMember.currentProductId}`
        window.open(link, '_blank')
    }

    loginSSOAllState(){
        var link = `${environment.apiBaseUrl}api/ssoAllstate/sso-login?memberId=${this.memberId}`
        window.open(link, '_blank')
    }

}


// WEBPACK FOOTER //
// ./src/app/home/home.component.ts